// LoginPage.jsx
import React, { useState } from 'react';
import Signin from '../Signin';
import Login from '../Login';
import { UseGlobellogin } from '../Logincontaxt.jsx/Logincontex';

const LoginPage = () => {
const {isSignin, setIsSignin} = UseGlobellogin();
  const toggleForm = () => {
    setIsSignin(!isSignin);
  };

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-10">
      <div className="bg-light rounded-lg shadow-lg p-6 w-full max-w-3xl" id="target-section">

        <div className="mb-6">
          {isSignin ? (
            <Signin setIsSignin={setIsSignin} toggleForm={toggleForm} />
          ) : (
            <Login handleClose={() => {}} setIsSignin={setIsSignin} />
          )}
        <div className="text-end mb-4">
          {/* <button onClick={toggleForm} className="th-btn style3">
            {isSignin ? "Switch to Log In" : "Switch to Sign Up"}{" "}
            <i className="fas fa-arrow-right ms-2" />
          </button> */}
        </div>
        </div>
      </div>
    // </div>
  );
};

export default LoginPage;
